var EasyDialogBox = (function () {
    'use strict';

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    function create(strId, strTypeClass, strTitle, strMessage) {
        var objId = strId + '_0';
        var hasHeading = strTypeClass.indexOf('dlg-disable-heading') === -1;
        var hasFooter = strTypeClass.indexOf('dlg-disable-footer') === -1;
        var disableEsc = strTypeClass.indexOf('dlg-disable-esc') !== -1;

        var dlg = document.createElement('div');
        dlg.id = objId;
        dlg.className = strTypeClass;
        document.body.appendChild(dlg);

        var box = document.createElement('div');
        box.id = objId + '_1';
        box.className = 'dlg-box';
        if (objId === 'newsletterPopup_0') {
            box.tabIndex = 0;
            box.classList.add('outline-focus-none');
        }
        dlg.appendChild(box);

        var closeX = document.createElement('span');
        closeX.className = 'dlg-close-x icon-x';
        closeX.tabIndex = 0;
        closeX.innerHTML = '&#215;';

        if (hasHeading) {
            var heading = document.createElement('div');
            heading.id = objId + '_1_heading';
            heading.className = 'dlg-heading';
            heading.appendChild(closeX);
            var titleEl = document.createElement('h3');
            titleEl.className = 'popup-title';
            titleEl.textContent = strTitle;
            heading.appendChild(titleEl);
            box.appendChild(heading);
        } else {
            box.appendChild(closeX);
        }

        var message = document.createElement('div');
        message.className = 'dlg-message';
        message.innerHTML = strMessage;
        box.appendChild(message);

        if (hasFooter) {
            var footer = document.createElement('div');
            footer.className = 'dlg-footer';
            box.appendChild(footer);
        }

        var escHandler = null;
        var destroyed = false;

        function fireClose() {
            if (typeof obj.onClose === 'function') {
                obj.onClose();
            }
        }

        var obj = {
            id: objId,
            onClose: function () {},
            onShow: function () {},
            onHide: function () {},
            onDestroy: function () {},

            show: function (nMsec) {
                if (nMsec !== 0 && typeof nMsec === 'number') {
                    var that = this;
                    setTimeout(function () { that.show(0); }, nMsec);
                    return;
                }
                dlg.classList.add('dialog-open');
                var sw = getScrollbarWidth();
                if (sw > 0) {
                    document.documentElement.style.paddingRight = sw + 'px';
                }
                document.documentElement.classList.add('dlg-stop-scrolling');
                this.onShow();

                if (!disableEsc) {
                    escHandler = function (e) {
                        if (e.key === 'Escape') {
                            document.removeEventListener('keydown', escHandler);
                            escHandler = null;
                            fireClose();
                        }
                    };
                    document.addEventListener('keydown', escHandler);
                }
            },

            destroy: function () {
                if (destroyed) return;
                destroyed = true;
                dlg.classList.remove('dialog-open');
                document.documentElement.classList.remove('dlg-stop-scrolling');
                if (escHandler) {
                    document.removeEventListener('keydown', escHandler);
                    escHandler = null;
                }
                this.onDestroy();
                setTimeout(function () {
                    if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
                }, 300);
            }
        };

        dlg.addEventListener('click', function (e) {
            if (e.target === dlg) fireClose();
        });

        closeX.addEventListener('click', fireClose);
        closeX.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                fireClose();
            }
        });

        return obj;
    }

    return { create: create };
})();

class Popup extends HTMLElement {
    constructor() {
        super();
        this.popup = null;
    }
    init() {
        this.initPopupJs();
    }
    initPopupJs(content = '', title = '', id = '', header = true, footer = true, timeShow = 0) {
        const _this = this;
        this.popup = EasyDialogBox.create(
            id,
            `dlg ${header === false ? 'dlg-disable-heading ' : ''}${footer === false ? 'dlg-disable-footer ' : ''}dlg-disable-drag`,
            title,
            content
        );
        this.popup.onClose = function () {
            removeTrapFocus();
            _this.popup.destroy();
            rootAction.remove();
            root.style.removeProperty('padding-right');
            if (_this.querySelector('button') && _this.querySelector('button').id) {
                const btn = document.querySelector('#' + _this.querySelector('button').id);
                if (btn) btn.focus();
            }
            getHeightHeader.init();
        };
        this.popup.show(timeShow);
    }
}
